import * as React from "react"
import styled from "@emotion/styled"
import { toast, ToastContainer, ToastOptions } from "react-toastify"
import { injectStyle } from "react-toastify/dist/inject-style"
import { Toast, ToastTitle } from "@indeed/ifl-components"
import { useIsMobile } from "../../hooks/useIsMobile"

// NOTE: should only ever be called once in the app
injectStyle()

const StyledToastContainer = styled(ToastContainer)`
    .Toastify__toast-container {}
    .Toastify__toast {
        padding-block-end: 0;
        padding-block-start: 0;
        padding-inline-end: 0;
        padding-inline-start: 0;
        overflow: visible;
        min-block-size: 100%;
        min-inline-size: 100%;        
        border-radius: 4px;
        box-shadow: none;
        background: none;
    }
    .Toastify__toast--error {}
    .Toastify__toast--warning {}
    .Toastify__toast--success {}
    .Toastify__toast-body {}
})
`

export const IndeedToastContainer: React.FC = () => {
    const isMobile = useIsMobile()
    return (
        <StyledToastContainer
            containerId="indeed-toast-container"
            position={isMobile ? toast.POSITION.BOTTOM_CENTER : toast.POSITION.BOTTOM_LEFT}
            autoClose={8000}
            limit={5}
            newestOnTop
            hideProgressBar
            closeButton={false}
            role="none"
            closeOnClick={false}
        />
    )
}

export type ToastFunction = (message: string | JSX.Element, title?: string, opts?: ToastOptions) => void

export const toastError: ToastFunction = (message, title, opts) => {
    toast(
        ({ closeToast }) => (
            <Toast status="critical" onDismiss={closeToast} dismissProps={{ "aria-hidden": true }}>
                {title && <ToastTitle as="h2">{title}</ToastTitle>}
                {message}
            </Toast>
        ),
        { ...opts, autoClose: false }
    )
}

export const toastInfo: ToastFunction = (message, title, opts) => {
    toast(
        ({ closeToast }) => (
            <Toast status="info" onDismiss={closeToast} dismissProps={{ "aria-hidden": true }}>
                {title && <ToastTitle>{title}</ToastTitle>}
                {message}
            </Toast>
        ),
        opts
    )
}

export const toastSuccess: ToastFunction = (message, title, opts) => {
    toast(
        ({ closeToast }) => (
            <Toast status="success" type="polite" onDismiss={closeToast} dismissProps={{ "aria-hidden": true }}>
                {title && <ToastTitle>{title}</ToastTitle>}
                {message}
            </Toast>
        ),
        opts
    )
}
